module.exports = __webpack_public_path__ + "img/icon_support.8827aef4.svg";